import { useEffect, useState } from 'react'

export const useHeaderHeight = () => {
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const el = document.querySelector<HTMLElement>('header')

    if (!el) return

    const update = () => {
      setHeight(el.offsetHeight)
    }

    update()

    const resizeObserver = new ResizeObserver(update)

    resizeObserver.observe(el)

    return () => resizeObserver.disconnect()
  }, [])

  return height
}
